import classNames from "classnames"
import { ErrorMessage, useField } from "formik"
import { motion } from "framer-motion"
import { useAnimation } from "utils/useAnimation"

const Select = ({ name, label, placeholder, options, disabled = false }) => {
  const [{ value }, { error, touched }, { setValue }] = useField(name)
  const { variants } = useAnimation()

  let selectOptions

  if (typeof options?.[0] === "string") {
    selectOptions = options.map((option) => {
      return {
        label: option,
        value: option,
      }
    })
  } else {
    selectOptions = options
  }

  return (
    <motion.div className="flex flex-col space-y-2 text-lg" variants={variants}>
      <label className="font-medium text-lg">{label}</label>
      <div
        className={classNames(
          "relative flex justify-between gap-x-3 border-b border-grey-600 pt-1 pb-2 font-semibold",
          error && touched && "border-red-500 !text-red-500",
          value === "" && "text-grey-400"
        )}
      >
        <select
          className={classNames(
            "flex-1 placeholder:text-red-500 w-max min-h-[28px] cursor-pointer outline-none",
            value === "" && "font-medium",
            error && touched && "max-w-[calc(100%-80px)]"
          )}
          onChange={(event) => setValue(event.target.value)}
          required
        >
          <option disabled selected={value === ""}>
            {placeholder}
          </option>
          {selectOptions.map((option, index) => (
            <option key={index} value={option.value} selected={value === option.value} disabled={disabled}>
              {option.label}
            </option>
          ))}
        </select>
        {error && touched && <ErrorMessage name="time" component="span" className="text-red-500 text-sm self-center" />}
      </div>
    </motion.div>
  )
}

export default Select
